export interface License {
    /** Whether the license has issues */
    has_issue: boolean;
    /** The issue type */
    issue_type: issue_type;
    /** The issue started datetime */
    issue_started_datetime: string;
}

export enum issue_type {
    none = "none",
    licensed_part_exceeded = "licensed_part_exceeded",
    no_connection_with_license_server = "no_connection_with_license_server"
}
